
//약관 - 팝업창
const ShowTerms = ({varTermsWin,setTermsWin,varCurrentTerm}) => {

  return varTermsWin && (
    <div className={varTermsWin?"layer__pop open":"layer__pop"} style={{zIndex:"100"}}>
      <div className="layer__terms">
        <div className="layer__pop__head">
          <div className="layer__pop__title">{varCurrentTerm.title}</div>
        </div>
        <div className="layer__pop__body" style={{padding:"10px"}}>
          <div className="layer__pop__text">{varCurrentTerm.comment}</div>
        </div>
        <div className="layer__pop__bottom">
          <button className="btn_style_yes close_layer" onClick={()=>setTermsWin(false)}>확인</button>
        </div>
      </div>
    </div>
  );
}
export default ShowTerms;